var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93 79H87V35.0725C87 32.8275 85.1725 31 82.9275 31H48V25H82.9275C88.48 25 93 29.5175 93 35.0725V79Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8774 41.1224L40.7574 29.9999L51.8774 18.8774L56.1224 23.1224L49.2424 29.9999L56.1224 36.8774L51.8774 41.1224Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72 93H37.0725C31.52 93 27 88.4825 27 82.9275V39H33V82.9275C33 85.1725 34.8275 87 37.0725 87H72V93Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1224 101.122L63.8774 96.8774L70.7574 89.9999L63.8774 83.1224L68.1224 78.8774L79.2424 89.9999L68.1224 101.122Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/Switch.424613cd.svg";
export { ForwardRef as ReactComponent };